import planetInSignChange from './actions/planetInSignChange';
import planetInSignCreate from './actions/planetInSignCreate';
import planetInSignDetail from './actions/planetInSignDetail';
import planetInSignList from './actions/planetInSignList';
import getPlanetInSign from './getters/getPlanetInSign';
import planetInSignUpload from './mutations/planetInSignUpload';

const actions = {
    planetInSignChange,
    planetInSignCreate,
    planetInSignDetail,
    planetInSignList
};

const mutations = {
    planetInSignUpload
};

const getters = {
    getPlanetInSign
};

export default { actions, mutations, getters };
